import Vue from 'vue';
import clientTransformer from '../../transformers/client';

const success = (data, resolve) => {
  const result = {
    errors: data.errors,
    data: clientTransformer.fetchCollection(data.data),
  };
  resolve(result);
};

const failed = (error, reject) => reject(error);

export default data => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/clients/update/bullkprocess', data)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client/bulkUpdate.js